import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';
import { IDriverAnalysis } from '../../utils/types';

interface IUseGetDriverAnalysis {
    id: string;
}
export const useGetDriverAnalysis = ({
    id
}: IUseGetDriverAnalysis) =>
    useQuery({
        queryKey: ["get_driver_analysis", id],
        queryFn: async (): Promise<IDriverAnalysis> => {
            const res = await apiClient.get(ENDPOINTS.DRIVER.GET_DRIVER_ANALYSIS(id));
            return res.data;
        },
    });